
import { useState } from 'react';
import { Card } from "@/components/ui/card";

const timelineItems = [
  {
    date: "July 2025",
    title: "AI Chat System 2.0",
    description: "Complete overhaul of our AI chat system with advanced context awareness and personality customization.",
    details: "Our next-generation AI chat system will feature improved natural language understanding, dynamic personality adaptation, and deeper context awareness. Users will be able to customize their bot's personality traits and behavioral patterns.",
    status: "current"
  },
  {
    date: "October 2025",
    title: "Advanced Server Analytics",
    description: "Introducing detailed analytics dashboard for server growth, engagement metrics, and user behavior insights.",
    details: "The new analytics dashboard will provide comprehensive insights into server activity, member engagement, and growth trends. Features will include custom report generation, real-time monitoring, and predictive analytics.",
    status: "upcoming"
  },
  {
    date: "January 2026",
    title: "Custom Commands Builder",
    description: "Visual command builder allowing server admins to create custom interactions without coding.",
    details: "A drag-and-drop interface for creating custom commands, with support for complex workflows, conditional logic, and integration with external services. Perfect for non-technical users who want to create powerful automations.",
    status: "upcoming"
  },
  {
    date: "April 2026",
    title: "Event Management System",
    description: "Comprehensive tools for organizing, scheduling, and managing server events.",
    details: "Plan and manage server events with features like automatic reminders, RSVP tracking, role-based permissions, and integration with popular calendar services. Perfect for communities that host regular events.",
    status: "upcoming"
  }
];

const RoadmapTimeline = () => {
  const [hoveredIndex, setHoveredIndex] = useState<number | null>(null);

  return (
    <div className="relative py-20">
      {/* Timeline line with dynamic expansion on hover */}
      <div className="absolute left-1/2 transform -translate-x-1/2 h-full transition-all duration-500" style={{
        width: hoveredIndex !== null ? '3px' : '1px',
        background: 'linear-gradient(to bottom, rgba(255, 105, 180, 0.8), rgba(255, 202, 212, 0.2))'
      }}></div>
      
      <div className="space-y-36 relative">
        {timelineItems.map((item, index) => (
          <div 
            key={index} 
            className="relative"
            onMouseEnter={() => setHoveredIndex(index)}
            onMouseLeave={() => setHoveredIndex(null)}
          >
            <div className="flex items-center justify-center">
              <div 
                className={`relative z-10 w-4 h-4 rounded-full cursor-pointer transition-all duration-300 ${
                  item.status === 'current' 
                    ? 'bg-fembot-pink animate-pulse-glow' 
                    : hoveredIndex === index
                    ? 'bg-fembot-pink scale-125'
                    : 'bg-fembot-light-pink'
                }`}
              />
            </div>
            
            <div className={`absolute top-0 w-1/2 ${
              index % 2 === 0 ? 'left-0 pr-12 text-right' : 'right-0 pl-12 text-left'
            }`}>
              <Card className={`p-6 transition-all duration-300 ${
                hoveredIndex === index ? 'transform scale-105 shadow-lg' : ''
              }`}>
                <div className="space-y-2">
                  <p className="text-sm font-medium text-fembot-pink">{item.date}</p>
                  <h3 className="font-bold text-lg dark:text-white">{item.title}</h3>
                  <p className="text-gray-600 dark:text-gray-300">{item.description}</p>
                  <div className={`overflow-hidden transition-all duration-300 ${
                    hoveredIndex === index ? 'max-h-96 opacity-100 mt-4' : 'max-h-0 opacity-0'
                  }`}>
                    <p className="text-gray-600 dark:text-gray-300 border-t pt-4">
                      {item.details}
                    </p>
                  </div>
                </div>
              </Card>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default RoadmapTimeline;
